import { flightsSessionStore } from "@flights/web-api-utils-universal";
import { useCallback, useEffect } from "react";
import useOfferCartOrderData from "./useOfferCartOrderData.js";
const key = "sirf_message_continuity";
const get = (offerToken) => {
    const storedData = flightsSessionStore.get(key) ?? {};
    return storedData[offerToken] ?? false;
};
const update = (offerToken, data) => {
    const storedData = flightsSessionStore.get(key) ?? {};
    storedData[offerToken] = data;
    flightsSessionStore.set(key, storedData);
};
const remove = (offerToken) => {
    const storedData = flightsSessionStore.get(key) ?? {};
    delete storedData[offerToken];
    flightsSessionStore.set(key, storedData);
};
const useSIRFMessageTracking = () => {
    const offerCartOrderData = useOfferCartOrderData();
    const getToken = useCallback((offerToken) => {
        const { parentOfferToken } = offerCartOrderData.get(offerToken);
        const token = typeof parentOfferToken === "string" ? parentOfferToken : offerToken;
        return token;
    }, [offerCartOrderData]);
    const trackFlightDetails = useCallback((offerToken) => {
        const token = getToken(offerToken);
        update(token, true);
    }, [getToken]);
    const trackSIRFDoc = useCallback((offerToken, hasValidDocs) => {
        const token = getToken(offerToken);
        const hasFDMessage = get(token);
        if (!hasValidDocs || !hasFDMessage) {
            remove(token);
        }
    }, [getToken]);
    const checkIfHasFDOnOrderCreation = useCallback((offerToken) => {
        const token = getToken(offerToken);
        const tokenData = get(token);
        return tokenData;
    }, [getToken]);
    const checkIfHasFDMessage = useCallback((offerToken) => {
        const token = getToken(offerToken);
        const tokenData = get(token);
        remove(token);
        return tokenData;
    }, [getToken]);
    const _debug = useCallback(() => flightsSessionStore.get(key) ?? {}, []);
    return {
        trackFlightDetails,
        trackSIRFDoc,
        checkIfHasFDOnOrderCreation,
        checkIfHasFDMessage,
        _debug
    };
};
export const useSIRFTrackFlightDetails = (flight) => {
    const { trackFlightDetails } = useSIRFMessageTracking();
    const token = flight?.token;
    const isSpanishResidentFare = flight?.subsidizedFares?.find((sf) => sf.type === "SPANISH_RESIDENT_FARE");
    useEffect(() => {
        if (token && isSpanishResidentFare) {
            trackFlightDetails(token);
        }
    }, [isSpanishResidentFare, token, trackFlightDetails]);
};
export default useSIRFMessageTracking;
